
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';

const initialState:any = {
  apiEndPoint: "reports/task",
  data:{},
  error:null
};

const taskReports = createSlice({
  name: initialState.apiEndPoint,
  initialState,
  reducers: {
   
    // get Item details
    setData(state, action) {
      state.data = action.payload;
    },
    hasError(state, action) {
      state.error = action.payload.error;
    }
  }
});


export default taskReports.reducer;

function getApiEndPoint(){
  return store.getState().taskReports.apiEndPoint
}

export const { setData } = taskReports.actions;


export function getTaskReport() {
  return async () => {
    try {
      const response = await axios.get(getApiEndPoint());
      dispatch(taskReports.actions.setData(response.data));
    } catch (error) {
      dispatch(taskReports.actions.hasError(error));
    }
  };
}
